import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_HomeBanner = _resolveComponent("HomeBanner");
  var _component_FeatureArea = _resolveComponent("FeatureArea");
  var _component_SwiperActivityArea = _resolveComponent("SwiperActivityArea");
  var _component_HomeQceit = _resolveComponent("HomeQceit");
  var _component_ExcellentWorkArea = _resolveComponent("ExcellentWorkArea");
  var _component_HomeContestInfomation = _resolveComponent("HomeContestInfomation");
  var _component_HomePartner = _resolveComponent("HomePartner");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_HomeBanner), _createVNode(_component_FeatureArea), _createVNode(_component_SwiperActivityArea), _createVNode(_component_HomeQceit), _createVNode(_component_ExcellentWorkArea), _createVNode(_component_HomeContestInfomation), _createVNode(_component_HomePartner)]);
}